<template>
  <v-dialog v-model="dialog" persistent width="400">
    <v-alert class="mb-0 white" color="deep-orange" text outlined>
      <v-row>
        <v-col class="d-flex align-center justify-center" cols="3"
          ><v-icon size="60" color="deep-orange">mdi-alert</v-icon></v-col
        >
        <v-divider vertical></v-divider>
        <v-col>
          <v-row class="pl-3 ml-n7">
            <v-card-title>Atenção</v-card-title>
          </v-row>
          <p>
            Esta operação tem potencial de impacto significativo. Você está
            certo de que deseja continuar?
          </p>
          <v-card-actions>
            <v-row justify="center" class="pa-2 mt-n4">
              <v-btn @click="close" class="mr-3"> Cancelar </v-btn>
              <v-btn @click="confirmar" class="error"> Confirmar </v-btn>
            </v-row>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-alert>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["dialog"],
  data() {
    return {
      snackbar: false,
      password: "",
    };
  },
  computed: {
    ...mapState("auth", ["token", "user"]),
  },
  created() {},
  methods: {
    close() {
      this.$emit("close");
    },
    async confirmar() {
      this.$emit("result", true);
    },
  },
};
</script>
